'use client'

import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ViewLandingPageEvent } from '_libs/common/event-tracker/events'
import { Screen } from 'constants/tracking/screens'
import { NO_CHANGES_TO_TAXES_URL } from 'constants/routes'
import { CountryCode } from '@marketplace-web/domain/country-data'

import SecondhandTaxesComponentsRenderer from './components/SecondhandTaxesComponentsRenderer'
import useSecondhandTaxesPageContent from './hooks/useSecondhandTaxesPageContent'

type Props = { countryCode: CountryCode }

const SecondhandTaxes = ({ countryCode }: Props) => {
  const content = useSecondhandTaxesPageContent(countryCode)
  const { track } = useTracking()

  useEffect(() => {
    track(
      ViewLandingPageEvent({
        screen: Screen.NoChangesToTaxes,
        path: NO_CHANGES_TO_TAXES_URL,
        referrer: document.referrer ? new URL(document.referrer).href : 'unknown',
      }),
    )
  }, [track])

  if (!content) return null

  return <SecondhandTaxesComponentsRenderer content={content} />
}

export default SecondhandTaxes
